module.exports = __webpack_public_path__ + "static/media/up.0189e73a.svg";